import { StylesConfig } from 'react-select';
import { VideoOption } from './StepsTypeVideo';

/**
 * Custom styles for the react-select component
 */
export const customSelectStyles: StylesConfig<VideoOption, false> = {
  container: (provided) => ({
    ...provided,
    minHeight: '31px', // Match Bootstrap sm height
  }),
  control: (provided) => ({
    ...provided,
    minHeight: '31px', // Match Bootstrap sm height
    height: '31px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '31px',
    padding: '0 8px',
  }),
  input: (provided) => ({
    ...provided,
    margin: '0',
    padding: '0',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '31px',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '4px',
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '4px',
  }),
  menu: (provided) => ({
    ...provided,
    overflow: 'hidden',
  }),
  option: (base, state) => {
    const { isFocused, isSelected } = state;
    let backgroundColor = 'white';

    if (isFocused) {
      backgroundColor = '#ffb5a5';
    } else if (isSelected) {
      backgroundColor = '#ff6251';
    }

    return {
      ...base,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      backgroundColor,
      '&:hover': {
        backgroundColor: '#ff6251',
        color: 'white',
      },
    };
  },
};
